type Props = {
  color?: string;
};

export default function SelectedPill({
  color = "var(--brand-primary-color)",
}: Props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.37 2.87123C18.7225 0.18095 14.4299 0.180943 11.7823 2.87122L2.79382 12.0047C0.146241 14.695 0.146243 19.0568 2.79382 21.747C5.44139 24.4373 9.73396 24.4373 12.3815 21.7471L21.37 12.6136C24.0176 9.92331 24.0176 5.5615 21.37 2.87123ZM16.8184 16.1113L8.14896 7.4419L7.44185 8.14901L16.1113 16.8184L16.8184 16.1113Z"
        fill={color}
      />
    </svg>
  );
}
